import * as _ from 'lodash';

export interface ModelError {
    message: string;
    code: number;
    key: string;
}

export interface Attrs {
    [key: string]: any;
}

export abstract class Model<M> {

    id: number;
    errors: ModelError[] = [];
    original: Attrs = {};

    constructor(props?: Attrs) {
        if (props) {
            for (const key of this.fillable()) {
                if (props.hasOwnProperty(key)) {
                    this[key] = props[key];
                }
            }
        }
        this.commit();
    }

    /**
     * Copy changes on fillable attributes to original
     */
    commit() {
        const isset = Object.keys(this);
        this.original = this.fillable().reduce((collect, key) => {
            if (isset.includes(key)) {
                collect[key] = this[key];
            }
            return collect;
        }, {});
    }

    /**
     * Copy original values to fillable attributes
     */
    rollback() {
        const isset = Object.keys(this.original);
        this.fillable().forEach(key => {
            if (isset.includes(key)) {
                this[key] = this.original[key];
            } else {
                delete this[key];
            }
        });
    }

    /**
     * Returns the model as a serialized JSON object
     *
     * @abstract
     * @returns
     *
     * @memberOf Model
     */
    json(): Object {
        return _(this).pick(this.serializeable()).value();
    }

    /**
     * Returns an array of the properties of this model that can be serialized
     *
     * @returns {string[]}
     *
     * @memberOf Model
     */
    abstract serializeable(): string[];


    /**
     * Properties of this model that can be set
     *
     * @abstract
     * @returns {string[]}
     *
     * @memberOf Model
     */
    abstract fillable(): string[];
}
